var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRouteMiniMapStroke = function SvgIconRouteMiniMapStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M12 1c6.075 0 11 4.904 11 10.953 0 .49-.045.966-.11 1.439l-1.628-.665c.02-.255.038-.513.038-.774 0-5.106-4.172-9.26-9.3-9.26a9.3 9.3 0 0 0-7.094 3.286h10.088c2.66 0 3.994 3.183 2.148 5.068l-1.7-.695.985-.98c.628-.626.182-1.7-.708-1.7L3.76 7.67a9.16 9.16 0 0 0-1.062 4.283c0 3.018 1.464 5.695 3.715 7.387l3.976-3.96.699 1.698L7.9 20.253a9.26 9.26 0 0 0 4.099.96c.261 0 .518-.017.774-.04l.67 1.625a11 11 0 0 1-1.444.108c-6.075 0-11-4.904-11-10.953S5.925 1 12 1m-.908 11.62c-.405-.97.601-1.975 1.577-1.568l10.173 4.151-.575 1.378-4.786.836-.835 4.762-1.386.57z"
  })));
};
export default SvgIconRouteMiniMapStroke;